import { createTheme } from "./createTheme";
export const ApricotTheme = createTheme({
  name: "apricot",
  colors: {
    white: "#FFF",
    black: "#000",
    primary: ["hsla(174, 61%, 94%, 1)", "hsla(173, 63%, 85%, 1)", "hsla(173, 63%, 75%, 1)", "hsla(173, 64%, 65%, 1)", "hsla(173, 64%, 50%, 1)", "hsla(172, 65%, 48%, 1)", "hsla(173, 65%, 46%, 1)", "hsla(172, 63%, 45%, 1)", "hsla(172, 64%, 43%, 1)", "hsla(172, 62%, 41%, 1)"],
    light: {
      /* Background */
      "bg-alias-1": "$white",
      "bg-alias-1-hover": "$cloud-1",
      "bg-alias-1-active": "$cloud-2",
      "bg-alias-2": "$cloud-2",
      "bg-alias-2-hover": "$cloud-3",
      "bg-alias-2-active": "$cloud-6",
      "bg-alias-3": "$cloud-1",
      "bg-alias-4": "$neutral-2",
      "bg-alias-4-hover": "$neutral-4",
      "bg-alias-4-active": "$neutral-7",
      "bg-alias-5": "$marine-6",
      "bg-alias-5-hover": "$marine-8",
      "bg-alias-5-active": "$marine-10",
      "bg-alias-6": "$neutral-1",
      "bg-alias-6-hover": "$neutral-2",
      "bg-alias-6-active": "$neutral-3",
      "bg-alias-primary-1": "$primary-5",
      "bg-alias-primary-1-hover": "$primary-8",
      "bg-alias-primary-1-active": "$primary-10",
      "bg-alias-primary-1-focus": "$primary-1",
      "bg-alias-primary-2": "$primary-1",
      "bg-alias-negative-1": "$beetle-5",
      "bg-alias-negative-1-hover": "$beetle-8",
      "bg-alias-negative-1-active": "$beetle-10",
      "bg-alias-negative-2": "$beetle-1",
      "bg-alias-warning-1": "$sunray-1",
      "bg-alias-warning-1-hover": "$sunray-8",
      "bg-alias-warning-1-active": "$sunray-10",
      "bg-alias-warning-2": "$sunray-1",
      "bg-alias-positive-1": "$botanic-5",
      "bg-alias-positive-1-hover": "$botanic-8",
      "bg-alias-positive-1-active": "$botanic-10",
      "bg-alias-positive-2": "$botanic-1",
      "bg-alias-info-1": "$marine-1",
      "bg-alias-info-1-hover": "$marine-2",
      "bg-alias-info-active": "$marine-4",
      "bg-alias-input-selection": "$primary-2",

      /* Border */
      "b-alias-1": "$cloud-2",
      "b-alias-1-hover": "$cloud-4",
      "b-alias-1-active": "$cloud-6",
      "b-alias-2": "$cloud-1",
      "b-alias-3": "$neutral-6",
      "b-alias-3-hover": "$neutral-8",
      "b-alias-3-active": "$neutral-10",
      "b-alias-4": "$marine-6",
      "b-alias-4-hover": "$marine-8",
      "b-alias-primary-1": "$primary-5",
      "b-alias-primary-1-hover": "$primary-8",
      "b-alias-primary-1-active": "$primary-10",
      "b-alias-primary-1-translucent": "hsla(172, 65%, 48%, 50%)",
      "b-alias-negative-1": "$beetle-6",
      "b-alias-negative-1-hover": "$beetle-8",
      "b-alias-negative-1-active": "$beetle-10",
      "b-alias-negative-1-translucent": "hsla(348, 98%, 53%, 50%)",
      "b-alias-negative-2": "$beetle-3",
      "b-alias-warning-1": "$sunray-6",
      "b-alias-warning-1-hover": "$sunray-8",
      "b-alias-warning-1-active": "$sunray-10",
      "b-alias-positive-1": "$botanic-6",
      "b-alias-positive-1-hover": "$botanic-8",
      "b-alias-positive-1-active": "$botanic-10",

      /* Icon */
      "icon-alias-1": "$marine-10",
      "icon-alias-2": "$marine-6",
      "icon-alias-primary-1": "$primary-6",
      "icon-alias-negative-1": "$beetle-6",
      "icon-alias-negative-2": "$beetle-10",
      "icon-alias-positive-1": "$botanic-6",
      "icon-alias-positive-2": "$botanic-10",
      "icon-alias-warning-1": "$sunray-6",
      "icon-alias-warning-2": "$sunray-10",
      "icon-alias-info-1": "$marine-6",

      /* Text */
      "text-alias-1": "$marine-10",
      "text-alias-1-hover": "$marine-10",
      "text-alias-1-active": "$marine-10",
      "text-alias-2": "$marine-6",
      "text-alias-2-hover": "$marine-8",
      "text-alias-2-active": "$marine-10",
      "text-alias-3": "$cloud-6",
      "text-alias-3-hover": "$cloud-8",
      "text-alias-3-active": "$cloud-10",
      "text-alias-4": "$marine-4",
      "text-alias-primary-1": "$primary-6",
      "text-alias-primary-1-hover": "$primary-8",
      "text-alias-primary-1-active": "$primary-8",
      "text-alias-negative-1": "$beetle-6",
      "text-alias-negative-1-hover": "$beetle-8",
      "text-alias-negative-1-active": "$beetle-10",
      "text-alias-negative-2": "$beetle-10",
      "text-alias-info-1": "$marine-6",
      "text-alias-info-1-hover": "$marine-8",
      "text-alias-info-1-active": "$marine-10",
      "text-alias-positive-1": "$botanic-6",
      "text-alias-positive-1-hover": "$botanic-8",
      "text-alias-positive-1-active": "$botanic-10",
      "text-alias-positive-2": "$botanic-10",
      "text-alias-warning-1": "$sunray-6",
      "text-alias-warning-1-hover": "$sunray-8",
      "text-alias-warning-1-active": "$sunray-10",
      "text-alias-warning-2": "$sunray-10",
      "text-alias-input-selection": "$marine-6",
      "text-alias-input-placeholder": "$marine-3"
    },
    dark: {
      /* Background */
      "bg-alias-1": "#2B2F3C",
      "bg-alias-1-hover": "$cloud-10",
      "bg-alias-1-active": "$cloud-10",
      "bg-alias-2": "$cloud-10",
      "bg-alias-2-hover": "$cloud-10",
      "bg-alias-2-active": "$cloud-7",
      "bg-alias-3": "$cloud-10",
      "bg-alias-4": "$neutral-dark-9",
      "bg-alias-4-hover": "$neutral-dark-4",
      "bg-alias-4-active": "$neutral-dark-2",
      "bg-alias-5": "$marine-7",
      "bg-alias-5-hover": "$marine-6",
      "bg-alias-5-active": "$marine-5",
      "bg-alias-6": "$neutral-dark-10",
      "bg-alias-6-hover": "$neutral-dark-9",
      "bg-alias-6-active": "$neutral-dark-8",
      "bg-alias-primary-1": "$primary-8",
      "bg-alias-primary-1-hover": "$primary-6",
      "bg-alias-primary-1-active": "$primary-5",
      "bg-alias-primary-1-focus": "$neutral-dark-9",
      "bg-alias-primary-2": "$neutral-dark-9",
      "bg-alias-negative-1": "$beetle-8",
      "bg-alias-negative-1-hover": "$beetle-6",
      "bg-alias-negative-1-active": "$beetle-5",
      "bg-alias-negative-2": "$beetle-10",
      "bg-alias-warning-1": "$sunray-8",
      "bg-alias-warning-1-hover": "$sunray-6",
      "bg-alias-warning-1-active": "$sunray-5",
      "bg-alias-warning-2": "$sunray-10",
      "bg-alias-positive-1": "$botanic-8",
      "bg-alias-positive-1-hover": "$botanic-6",
      "bg-alias-positive-1-active": "$botanic-5",
      "bg-alias-positive-2": "$botanic-10",
      "bg-alias-info-1": "$marine-7",
      "bg-alias-info-1-hover": "$marine-5",
      "bg-alias-info-active": "$marine-4",
      "bg-alias-input-selection": "$primary-10",

      /* Border */
      "b-alias-1": "$neutral-dark-7",
      "b-alias-1-hover": "$neutral-dark-5",
      "b-alias-1-active": "$neutral-dark-4",
      "b-alias-2": "$neutral-dark-9",
      "b-alias-3": "$neutral-dark-5",
      "b-alias-3-hover": "$neutral-dark-8",
      "b-alias-3-active": "$neutral-dark-10",
      "b-alias-4": "$marine-5",
      "b-alias-4-hover": "$marine-7",
      "b-alias-primary-1": "$primary-8",
      "b-alias-primary-1-hover": "$primary-5",
      "b-alias-primary-1-active": "$primary-4",
      "b-alias-primary-1-translucent": "hsla(172, 63%, 45%, 50%)",
      "b-alias-negative-1": "$beetle-8",
      "b-alias-negative-1-hover": "$beetle-7",
      "b-alias-negative-1-active": "$beetle-6",
      "b-alias-negative-1-translucent": "hsla(348, 83%, 50%, 50%)",
      "b-alias-negative-2": "$beetle-3",
      "b-alias-warning-1": "$sunray-8",
      "b-alias-warning-1-hover": "$sunray-7",
      "b-alias-warning-1-active": "$sunray-6",
      "b-alias-positive-1": "$botanic-8",
      "b-alias-positive-1-hover": "$botanic-7",
      "b-alias-positive-1-active": "$botanic-6",

      /* Icon */
      "icon-alias-1": "$white",
      "icon-alias-2": "$cloud-6",
      "icon-alias-primary-1": "$primary-8",
      "icon-alias-negative-1": "$beetle-8",
      "icon-alias-negative-2": "$beetle-1",
      "icon-alias-positive-1": "$botanic-8",
      "icon-alias-positive-2": "$botanic-1",
      "icon-alias-warning-1": "$sunray-8",
      "icon-alias-warning-2": "$sunray-1",
      "icon-alias-info-1": "$marine-2",

      /* Text */
      "text-alias-1": "$white",
      "text-alias-1-hover": "$white",
      "text-alias-1-active": "$white",
      "text-alias-2": "$cloud-4",
      "text-alias-2-hover": "$cloud-2",
      "text-alias-2-active": "$cloud-1",
      "text-alias-3": "$cloud-8",
      "text-alias-3-hover": "$cloud-7",
      "text-alias-3-active": "$cloud-6",
      "text-alias-4": "$marine-4",
      "text-alias-primary-1": "$primary-6",
      "text-alias-primary-1-hover": "$primary-5",
      "text-alias-primary-1-active": "$primary-5",
      "text-alias-negative-1": "$beetle-8",
      "text-alias-negative-1-hover": "$beetle-7",
      "text-alias-negative-1-active": "$beetle-6",
      "text-alias-negative-2": "$beetle-1",
      "text-alias-warning-1": "$sunray-8",
      "text-alias-warning-1-hover": "$sunray-7",
      "text-alias-warning-1-active": "$sunray-6",
      "text-alias-warning-2": "$sunray-1",
      "text-alias-positive-1": "$botanic-8",
      "text-alias-positive-1-hover": "$botanic-7",
      "text-alias-positive-1-active": "$botanic-6",
      "text-alias-positive-2": "$botanic-1",
      "text-alias-info-1": "$marine-2",
      "text-alias-info-1-hover": "$marine-4",
      "text-alias-info-1-active": "$marine-5",
      "text-alias-input-selection": "$white",
      "text-alias-input-placeholder": "$marine-3"
    }
  }
});